import { Tooltip } from '@mui/material';
import isEmpty from 'lodash/isEmpty';
import { ReactElement, ReactNode } from 'react';

export function CorlTooltip({ children, title, enabled }: Readonly<{ children: ReactElement; title: ReactNode; enabled: boolean }>) {
  if (isEmpty(title)) return children;

  if (enabled) {
    return (
      <Tooltip title={title!} placement="top">
        {children}
      </Tooltip>
    );
  }

  return children;
}
